import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowId, WorkflowInfo} from "common/flowmaster/types/workflow";

export type WorkflowDuplicateAction = {
  type: WorkflowsActionTypes["WORKFLOW_DUPLICATE"]["SUCCESS"];
  payload: WorkflowInfo;
};

export default function duplicateWorkflow(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_DUPLICATE,
    (organisationId: OrganisationId, workflowId: WorkflowId) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/workflow/${workflowId}/duplicate`,
          {},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
